// "New version ready" prompt, shared by the office app (app.js) and the techs
// app (techs.js). A floating navy pill at the bottom of the screen — it never
// pushes the layout around, and it never reloads by itself (that could wipe an
// unsaved note or logged hours). Reload picks up the new service worker.

const REFRESH_ICON = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-2.64-6.36"/><path d="M21 3v6h-6"/></svg>`;

export function showUpdatePrompt({ lang = 'EN' } = {}) {
  if (document.getElementById('update-prompt')) return;
  const es = lang === 'ES';
  const el = document.createElement('div');
  el.id = 'update-prompt';
  el.className = 'update-prompt';
  el.setAttribute('role', 'status');
  el.innerHTML = `
    <span class="update-prompt-icon">${REFRESH_ICON}</span>
    <span class="update-prompt-text">
      <b>${es ? 'Nueva versión lista' : 'New version ready'}</b>
      <small>${es ? 'Recarga cuando te convenga' : 'Reload when you&rsquo;re at a good stopping point'}</small>
    </span>
    <button type="button" class="update-prompt-reload">${es ? 'Recargar' : 'Reload'}</button>
    <button type="button" class="update-prompt-close" aria-label="${es ? 'Más tarde' : 'Later'}">&times;</button>`;
  el.querySelector('.update-prompt-reload').addEventListener('click', () => window.location.reload());
  el.querySelector('.update-prompt-close').addEventListener('click', () => {
    el.classList.remove('is-in');
    setTimeout(() => el.remove(), 250);
  });
  document.body.appendChild(el);
  requestAnimationFrame(() => el.classList.add('is-in'));
}
